module.exports = __webpack_public_path__ + "img/16_59.cdd13bde.png";